import { MediaType } from './teachertraining';

export interface DownloadResponse {
  download: string; // Assuming the "download" property is a JSON string
}

export enum DownloadStateTitle {
  Done = 'Done',
  Download = 'Download',
}

export enum ModelDownloadName {
  Training = 'training',
  LessonDetail = 'lessonDetail',
}

export interface DownloadInfo {
  id: number;
  file: string;
  url: string;
  status: string;
  error: string;
  downloaded: number;
  total: number;
  tag: DownloadTag;
}

export interface DownloadTag {
  timestamp: number;
  mediaType?: MediaType;
  modelDownloadName: ModelDownloadName;
  modelDownloadRequestId: number;
  modelDownloadAddedInformation?: { [key: string]: any };
}
export interface DownloadRequest extends DownloadTag {
  id: number;
  url: string;
  downloadId?: number;
  download?: DownloadInfo;
}

export enum DownloadListener {
  OnAdded = 'onAdded',
  OnProgress = 'onProgress',
  OnError = 'onError',
  OnCompleted = 'onCompleted',
  OnRemoved = 'onRemoved',
  OnDeleted = 'onDeleted',
  onCancelled = 'onCancelled',
}

export enum DownloadStatus {
  None = 'NONE',
  Queued = 'QUEUED',
  Downloading = 'DOWNLOADING',
  Paused = 'PAUSED',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Removed = 'REMOVED',
  Deleted = 'DELETED',
  Added = 'ADDED',
  FileAllocationFailed = 'FILEALLOCATIONFAILED',
}

export const DownloadErrorCodes = {
  unknown: 'UNKNOWN',
  none: 'NONE',
  fileNotCreated: 'FILE_NOT_CREATED',
  connectionTimedOut: 'CONNECTION_TIMED_OUT',
  unknownHost: 'UNKNOWN_HOST',
  httpNotFound: 'HTTP_NOT_FOUND',
  writePermissionDenied: 'WRITE_PERMISSION_DENIED',
  noStorageSpace: 'NO_STORAGE_SPACE',
  noNetworkConnection: 'NO_NETWORK_CONNECTION',
  emptyResponseFromServer: 'EMPTY_RESPONSE_FROM_SERVER',
  requestAlreadyExist: 'REQUEST_ALREADY_EXIST',
  downloadNotFound: 'DOWNLOAD_NOT_FOUND',
  fetchDatabaseError: 'FETCH_DATABASE_ERROR',
  requestWithIdAlreadyExist: 'REQUEST_WITH_ID_ALREADY_EXIST',
  requestNotSuccessful: 'REQUEST_NOT_SUCCESSFUL',
  unknownIoError: 'UNKNOWN_IO_ERROR',
  fileNotFound: 'FILE_NOT_FOUND',
  fetchFileServerUrlInvalid: 'FETCH_FILE_SERVER_URL_INVALID',
  invalidContentHash: 'INVALID_CONTENT_HASH',
  failedToUpdateRequest: 'FAILED_TO_UPDATE_REQUEST',
  failedToAddCompletedDownload: 'FAILED_TO_ADD_COMPLETED_DOWNLOAD',
  fetchFileServerInvalidResponse: 'FETCH_FILE_SERVER_INVALID_RESPONSE',
  requestDoesNotExist: 'REQUEST_DOES_NOT_EXIST',
  enqueueNotSuccessful: 'ENQUEUE_NOT_SUCCESSFUL',
  completedNotAddedSuccessfully: 'COMPLETED_NOT_ADDED_SUCCESSFULLY',
  enqueuedRequestsAreNotDistinct: 'ENQUEUED_REQUESTS_ARE_NOT_DISTINCT',
  failedToRenameIncompleteDownloadFile:
    'FAILED_TO_RENAME_INCOMPLETE_DOWNLOAD_FILE',
  failedToRenameFile: 'FAILED_TO_RENAME_FILE',
  fileAllocationFailed: 'FILE_ALLOCATION_FAILED',
  httpConnectionNotAllowed: 'HTTP_CONNECTION_NOT_ALLOWED',
};
